import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full flex flex-col gap-10 p-4" }

import { IonPage, IonContent } from '@ionic/vue';
import SubcustomerData from '@/components/DetailPage/TeamPage/SubcustomerData.vue'
import TeamsData from '@/components/DetailPage/TeamPage/TeamsData.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'TeamsPage',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(SubcustomerData),
            _createVNode(TeamsData)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})